<template lang="pug">
InheritWrapper(v-model="inherit" :readonly="innerSetting.ReadOnly || disabled")
  BriqCheckbox(
    :label="innerSetting.DisplayName"
    :help="innerSetting.Description"
    v-model="innerValue"
    :disabled="innerSetting.ReadOnly || disabled ? true : inherit"
  )
</template>

<script>
import InheritWrapper from '@v/settings/application/advanced/InheritWrapper.vue'
import setupInheritedField from './setupInheritedField.js'
import { toRefs } from '@vue/composition-api'
import mixin from '@v/settings/application/advanced/mixin.js'

export default {
  components: { InheritWrapper },
  mixins: [mixin],
  props: {
    setting: {
      type: Object,
      required: true,
    },
    disabled: Boolean,
  },
  setup: (props, { emit }) => toRefs(setupInheritedField({ props, cast: 'bool', emit })),
}
</script>
